export enum BatchUpdateTemplateType {
  AttributeUpdate = 'batch_attribute_update',
  CreateEvent = 'batch_create_event',
}
